<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box">
        <el-card class="banner" shadow="never">
          <div class="banner-title"></div>
          <div class="order-info">
            <img
              v-if="product.image"
              :src="product.image"
              alt="封面"
              class="product-cover"
              style="width: 100px; height: 75px; object-fit: cover; margin-right: 15px; border-radius: 4px;"
            />
            <div class="info-text">
              <div class="row"><span>名称：</span><span class="name">{{ product.title }}</span></div>
              <div class="row"><span>价格：</span><span class="price">¥{{ price }}</span></div>
            </div>
          </div>
        </el-card>

        <el-card class="pay-card" shadow="never">
          <div class="methods">
            <div class="label">支付方式</div>
            <div class="btns">
              <div class="pay-btn" :class="{ active: payMethod==='wechat' }" @click="payMethod='wechat'">
                <img src="@/assets/image/weixin.png" alt="微信支付" class="pay-icon">
                微信支付
              </div>
              <div class="pay-btn" :class="{ active: payMethod==='alipay' }" @click="payMethod='alipay'">
                <img src="@/assets/image/zhifubao.png" alt="支付宝支付" class="pay-icon">
                支付宝支付
              </div>
            </div>
          </div>

          <div class="qr-wrap">
            <div class="qr-box" v-loading="requestingPayUrl" element-loading-text="加载中...">
              <img v-if="qrCodeDataUrl && !requestingPayUrl" :src="qrCodeDataUrl" alt="支付二维码" class="qr-img" />
              <div v-else-if="!requestingPayUrl" class="qr-placeholder">
                {{ orderNo ? '暂无支付二维码，请点击重新获取' : '缺少订单号，请返回上一步创建订单' }}
              </div>
            </div>
            <div v-if="qrCodeDataUrl && !requestingPayUrl" class="qr-tip">请用{{ payMethod==='wechat' ? '微信' : '支付宝' }}扫码，支付 <span class="price">¥{{ price }}</span></div>
            <div v-else-if="requestingPayUrl" class="qr-tip">正在获取支付二维码...</div>
            <div v-else class="qr-tip">
               {{ orderNo ? '点击下方按钮获取支付信息' : '缺少订单号，无法发起支付' }}
            </div>
            <el-button
              v-if="orderNo && !qrCodeDataUrl"
              type="primary"
              size="small"
              :loading="requestingPayUrl"
              @click="requestPayUrl"
            >
              重新获取支付二维码
            </el-button>
          </div>
        </el-card>
      </div>
    </main>

    <el-dialog
      title=""
      :visible.sync="showSuccessDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      custom-class="success-dialog"
      center
    >
      <div class="success-content">
        <div class="success-icon-wrap">
          <img :src="require('@/assets/image/caozuochenggong.png')" class="success-main-img" alt="操作成功" />
          <img :src="require('@/assets/image/icon_right.png')" class="success-check-icon" alt="成功" />
        </div>
        <div class="success-text">
          <div class="title">操作成功</div>
          <div class="desc">商品购买成功，可以去查看订单了哦！</div>
        </div>
        <el-button type="primary" class="confirm-btn" @click="onConfirmSuccess">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { payOrder, getOrderPaymentStatus } from '@/api/orderApi'
import { getMallProductDetail } from '@/api/mallApi'
import QRCode from 'qrcode'

export default {
  name: 'ProductPayment',
  data() {
    return {
      productId: null,
      orderNo: null,
      payUrl: '',
      qrCodeDataUrl: '',
      product: { title: '商品', price: 0, image: '' },
      payMethod: 'wechat',
      showSuccessDialog: false,
      pollingTimer: null,
      requestingPayUrl: false,
      missingOrderWarned: false,
      productLoading: false,
      totalAmount: 0
    }
  },
  created() {
    this.init()
  },
  beforeDestroy() {
    this.stopPaymentPolling()
  },
  watch: {
    '$route.params.id': 'init',
    payMethod() {
      this.payUrl = ''
      this.qrCodeDataUrl = ''
      if (this.orderNo) {
        this.requestPayUrl()
      }
    }
  },
  computed: {
    price() {
      return Number(this.totalAmount || 0).toFixed(2)
    }
  },
  methods: {
    toNumber(val) {
      if (val == null || val === '') return null
      const n = Number(val)
      return Number.isFinite(n) ? n : null
    },
    sanitizeUrl(val) {
      const s = String(val || '').trim()
      if (!s) return ''
      return s.replace(/`/g, '').trim()
    },
    applyPayMethodFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}
      const payType = this.toNumber(query.payType)
      if (payType === 1) this.payMethod = 'wechat'
      if (payType === 2) this.payMethod = 'alipay'
    },
    applyProductFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}
      const title = String(query.title || query.productName || query.name || '').trim()
      const image = this.sanitizeUrl(query.image || query.coverImage || query.img)
      const totalAmountRaw = this.toNumber(query.totalAmount || query.amount || query.total)

      const hasAny = Boolean(title) || Boolean(image) || totalAmountRaw != null
      if (!hasAny) return false

      if (title) this.product.title = title
      if (image) this.product.image = image
      if (totalAmountRaw != null) this.totalAmount = Number(totalAmountRaw) || 0
      return true
    },
    async isOrderPaid() {
      const orderNo = String(this.orderNo || '').trim()
      if (!orderNo) return false
      try {
        const res = await getOrderPaymentStatus(orderNo)
        const data = res && res.data ? res.data : null
        return Boolean(data && data.payStatus === 1)
      } catch (e) {
        return false
      }
    },
    async init() {
      const id = this.$route && this.$route.params ? this.$route.params.id : null
      this.productId = id

      const queryOrderNo = this.$route && this.$route.query && this.$route.query.orderNo
      const storedOrderNo = localStorage.getItem('productOrderNo')
      const storedProductId = localStorage.getItem('productOrderProductId')

      if (queryOrderNo) {
        this.orderNo = queryOrderNo
        try {
          localStorage.setItem('productOrderNo', String(queryOrderNo))
          localStorage.setItem('productOrderProductId', String(id || ''))
        } catch (e) {
          void e
        }
      } else if (storedOrderNo && storedProductId != null && String(storedProductId) === String(id)) {
        this.orderNo = storedOrderNo
      } else {
        this.orderNo = null
      }

      this.payUrl = ''
      this.qrCodeDataUrl = ''
      this.totalAmount = 0
      this.product = { title: '商品', price: 0, image: '' }

      this.applyPayMethodFromRoute()
      const applied = this.applyProductFromRoute()
      if (!applied) await this.ensureProductLoaded()

      if (!this.orderNo) {
        this.stopPaymentPolling()
        if (!this.missingOrderWarned) {
          this.missingOrderWarned = true
          this.$message.error('缺少订单号，请返回上一步创建订单')
        }
        return
      }

      const paid = await this.isOrderPaid()
      if (paid) {
        this.stopPaymentPolling()
        this.showSuccessDialog = true
        return
      }

      this.requestPayUrl()
      this.startPaymentPolling()
    },
    async ensureProductLoaded() {
      if (this.productLoading) return
      if (!this.productId) return

      this.productLoading = true
      try {
        const res = await getMallProductDetail(this.productId)
        const data = res && res.data ? res.data : null
        if (data) {
          const title = String(data.productName || '商品')
          const image = this.sanitizeUrl(data.productImage || data.coverImage || '')
          const amount = Number(data.price || 0)
          this.product = { title, price: amount, image }
          if (!this.totalAmount) this.totalAmount = amount
        }
      } catch (err) {
        this.$message.error((err && err.message) || '获取详情失败')
      } finally {
        this.productLoading = false
      }
    },
    startPaymentPolling() {
      this.stopPaymentPolling()
      if (!this.orderNo) return

      this.pollingTimer = setInterval(async () => {
        try {
          const res = await getOrderPaymentStatus(this.orderNo)
          const data = res && res.data ? res.data : null
          if (data && data.payStatus === 1) {
            this.stopPaymentPolling()
            this.$message.success('支付成功')
            this.$router.push({ name: 'memberOrders' })
          }
        } catch (e) {
          void e
        }
      }, 1000)
    },
    stopPaymentPolling() {
      if (this.pollingTimer) {
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },
    async requestPayUrl() {
      if (this.requestingPayUrl) return
      const orderNo = String(this.orderNo || '').trim()
      if (!orderNo) return

      const paymentType = this.payMethod === 'alipay' ? 2 : 1
      try {
        this.requestingPayUrl = true
        this.payUrl = ''
        this.qrCodeDataUrl = ''
        const res = await payOrder({ orderNo, paymentType })
        const data = res && res.data != null ? res.data : null

        let nextPayUrl = ''
        if (typeof data === 'string') {
          if (data.trim().startsWith('<')) {
            nextPayUrl = this.buildPayUrlFromPaymentForm(data)
          } else {
            nextPayUrl = data
          }
        } else if (data && typeof data === 'object') {
          if (data.paymentParams) {
            nextPayUrl = data.paymentParams.codeUrl || data.paymentParams.paymentUrl || data.paymentParams.qrUrl || ''
          }
          if (!nextPayUrl) {
            const paymentForm = data.paymentForm || data.payForm || ''
            nextPayUrl = data.payUrl || data.qrUrl || data.url || this.buildPayUrlFromPaymentForm(paymentForm) || ''
          }
        }

        if (!nextPayUrl) {
          this.$message.error('发起支付失败')
          return
        }
        this.payUrl = String(nextPayUrl).trim()
        await this.generateQRCode(this.payUrl)
        this.startPaymentPolling()
      } catch (err) {
        this.$message.error((err && err.message) || '发起支付失败')
      } finally {
        this.requestingPayUrl = false
      }
    },
    sanitizePaymentFormHtml(html) {
      return String(html || '').replace(/`/g, '').trim()
    },
    sanitizeGatewayUrl(url) {
      return String(url || '').replace(/`/g, '').replace(/\\+$/g, '').trim()
    },
    buildPayUrlFromPaymentForm(paymentFormHtml) {
      const raw = this.sanitizePaymentFormHtml(paymentFormHtml)
      if (!raw) return ''
      if (typeof window === 'undefined' || typeof DOMParser === 'undefined') return ''

      try {
        const parser = new DOMParser()
        const doc = parser.parseFromString(raw, 'text/html')
        const form = doc.querySelector('form')
        if (!form) return ''

        const action = this.sanitizeGatewayUrl(form.getAttribute('action') || '')
        if (!action) return ''

        const url = new URL(action, window.location.origin)
        const inputs = Array.from(form.querySelectorAll('input[name]'))
        inputs.forEach(input => {
          const name = input.getAttribute('name')
          if (!name) return
          const value = input.value != null ? String(input.value) : String(input.getAttribute('value') || '')
          url.searchParams.set(name, value)
        })
        return url.toString()
      } catch (e) {
        return ''
      }
    },
    async generateQRCode(url) {
      const data = String(url || '').trim()
      if (!data) {
        this.qrCodeDataUrl = ''
        return
      }

      try {
        const qrCodeDataUrl = await QRCode.toDataURL(data, {
          width: 200,
          margin: 2,
          color: {
            dark: '#000000',
            light: '#FFFFFF'
          }
        })
        this.qrCodeDataUrl = qrCodeDataUrl
      } catch (err) {
        this.qrCodeDataUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(data)}`
      }
    },
    onConfirmSuccess() {
      this.showSuccessDialog = false
      this.$router.push({ name: 'memberOrders' })
    }
  }
}
</script>

<style scoped lang="scss">
.page-container { min-height: 100vh; display: flex; flex-direction: column; }
.main-content { flex: 1; padding-top: 20px; }

.banner { background: #4f46e5; color: #fff; }
.banner-title { font-size: 18px; font-weight: 600; padding: 12px 16px; }
.order-info { display: flex; gap: 20px; padding: 10px 16px; }
.order-info .name { color: #fff; }
.order-info .price { color: #ff4d4f; font-weight: 700; }

.pay-card { margin-top: 12px; }
.methods { margin-top: 16px; margin-bottom: 16px; }
.methods .label { font-weight: 600; margin-bottom: 12px; display: block; }
.btns { display: flex; gap: 16px; }

.pay-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 14px;
  background-color: white;
}

.pay-btn.active {
  border-color: #3E2CCD;
  background-color: #F5F3FF;
  color: #3E2CCD;
}

.pay-icon { width: 16px; height: 16px; object-fit: contain; }

.qr-wrap { display: flex; flex-direction: column; align-items: center; padding: 20px 0; }
.qr-box { width: 220px; height: 220px; display: flex; align-items: center; justify-content: center; border: 1px dashed #e4e7ed; border-radius: 8px; background: #fff; }
.qr-img { width: 200px; height: 200px; object-fit: contain; }
.qr-placeholder { color: #909399; font-size: 12px; text-align: center; padding: 0 12px; }
.qr-tip { margin-top: 12px; color: #606266; font-size: 14px; }
.qr-tip .price { color: #ff4d4f; font-weight: 700; }
</style>
